import { Link } from 'found'
import React, { Component } from 'react'
// import Prismic from 'prismic-javascript'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro';

import Brand from './brand'
import Footer from './footer'
import Wrapper from './wrapper'
import NavigationBar from './navigation-bar'
import ErrorPage from '../error-page/error-page'

import sgLogo from '../../images/sg-logo.svg'
import arrowIcon from '../../images/arrow.svg'
import searchIcon from '../../images/search_1.svg'
import linkedinIcon from '../../images/email/linkedin.png'
import youtubeIcon from '../../images/youtube.svg'
import instagramIcon from '../../images/instagram.svg'
import arrowDownIcon from '../../images/arrow-down.svg'
// import checkoutBasketIcon from '../../images/checkout_basket.svg'
import shareTwitterIcon from '../../images/icon-share-twitter.svg'
import shareFacebookIcon from '../../images/icon-share-facebook.svg'

const apiEndpoint = 'https://startupguide.prismic.io/api/v2'

class App extends Component {

  constructor() {
    super()
    this.state = {
      hasError: false,
      isNavigationOpened: false,
      isSearchOpened: false,
      citiesSearchValue: '',
      categoriesSearchValue: '',
      storesSearchValue: '',
      navigationOpacity: 0,
    }
  }

  componentWillMount = () => {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll)
  }

  // componentDidUpdate() {
  //   if (window.PrismicToolbar)
  //     window.PrismicToolbar.setup(apiEndpoint)
  // }

  componentDidCatch(error, info) {
    this.setState({ hasError: true, error, info });
  }

  handleScroll = (event) => {
    this.setState({
      navigationOpacity: window.scrollY / 500,
    })
  }

  render() {
    // console.log(this.state)

    if (this.state.hasError) {
      return <ErrorPage error={this.state.error} info={this.state.info} />
    }

    let i = 0
    // const { cities, citiesLink, categories, categoriesLink,storesLink, stores, onlineStoreLink, aboutLink } = this.props
    const { cities, citiesLink, onlineStoreLink } = this.props
    const citiesSearchFilter = c => this.state.citiesSearchValue === '' || c.name.toLowerCase().includes(this.state.citiesSearchValue)
    // const categoriesSearchFilter = c => this.state.categoriesSearchValue === '' || c.name.toLowerCase().includes(this.state.categoriesSearchValue)
    // const storesSearchFilter = c => this.state.storesSearchValue === '' || c.name.toLowerCase().includes(this.state.storesSearchValue)
    const menuSearchStyle = {
      backgroundColor: "#fff",
      padding: "1px 5% 1px 5%",
    }
    return (
      <Wrapper>
        <div data-collapse="small" data-animation="default" data-duration="400" className="w-hidden-main w-hidden-medium w-nav">
          <nav
            id="mobile-nav"
            data-w-id="2b73e092-8a7d-b7c7-1d68-ebf165b077ef"
            className="container-7 w-hidden-main w-container"
            style={{ backgroundColor: 'rgba(255, 255, 255, ' + this.state.navigationOpacity + ')' }}
          >
            <Link to="/" className="brand-2 w-nav-brand">
              <img src={sgLogo} width="70" alt="" className="image-52" />
            </Link>
            <div
              className={`menu-button w-nav-button ${this.state.isNavigationOpened ? 'w--open' : ''}`}
              onClick={() => { this.setState({ isNavigationOpened: !this.state.isNavigationOpened }) }}
            >
              <div
                className="top-line" data-ix="navbar"
                style={{
                  transformStyle: this.state.isNavigationOpened ? 'preserve-3d' : '',
                  transition: 'transform 200ms ease 0s',
                  transform: this.state.isNavigationOpened ? 'translateX(0px) translateY(9px) translateZ(0px) rotateX(0deg) rotateY(0deg) rotateZ(45deg)' : 'translateX(0px) translateY(0px) translateZ(0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg)',
                }}
              />
              <div
                className="middle-line"
                style={{
                  transformStyle: '',
                  transition: this.state.isNavigationOpened ? 'width 0ms ease 0s' : 'width 300ms ease 0s',
                  width: this.state.isNavigationOpened ? '0px' : '40px'
                }}
              />
              <div
                className="bottom-line"
                style={{
                  transformStyle: this.state.isNavigationOpened ? 'preserve-3d' : '',
                  transition: 'transform 200ms ease 0s',
                  transform: this.state.isNavigationOpened ? 'translateX(0px) translateY(-11px) translateZ(0px) rotateX(0deg) rotateY(0deg) rotateZ(-45deg)' : 'translateX(0px) translateY(0px) translateZ(0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg)',
                }}
              />
            </div>
            <div id="nav-mobile" className="nav-mobile-diogo" data-ix="navbar" style={{
              display: this.state.isNavigationOpened ? 'block' : 'none',
              opacity: this.state.isNavigationOpened ? "1" : "0",
              height: this.state.isNavigationOpened ? "100%" : "0px",
              transition: this.state.isNavigationOpened ? "transform 200 ease 0, height 200 ease-in 0, opacity 200 ease 0" : "opacity 200 ease 0, height 200 ease 0"
            }}>
              <div className="link-block-18 top w-inline-block" style={menuSearchStyle}>
                <form action="/search" className="search-2 nav-search-form">
                  <input type="search" className="search-input-3 w-input nav-search-input" maxLength={256} name="query" placeholder="Type to search" id="menu-search" required />
                  <div className="div-block-94">
                    <input type="submit" defaultValue="RESULTS" className="search-button-2 w-button" />
                    <img alt="" src={arrowDownIcon} width={18} className="image-85" />
                  </div>
                </form>
              </div>
              <Link className="link-block-18 w-inline-block" onClick={() => { this.setState({ isNavigationOpened: false }) }} to={citiesLink}>
                <div className="text-block-102">All Locations</div>
              </Link>
              <Link className="link-block-18 w-inline-block" onClick={() => { this.setState({ isNavigationOpened: false }) }} to={"/about"}>
                <div className="text-block-102">About us</div>
              </Link>
              <Link className="link-block-18 w-inline-block" onClick={() => { this.setState({ isNavigationOpened: false }) }} to={onlineStoreLink}>
                <div className="text-block-102">SHOP</div>
              </Link>
              <div className="div-block-133">
                <a href="https://www.facebook.com/StartupGuideHQ/" target="_blank" rel="noopener noreferrer" className="link-block-19 w-inline-block">
                  <img src={shareFacebookIcon} width="30" alt="" />
                </a>
                <a href="https://twitter.com/startupguidehq" target="_blank" rel="noopener noreferrer" className="link-block-19 w-inline-block">
                  <img src={shareTwitterIcon} width="30" alt="" />
                </a>
                <a href="https://www.instagram.com/startupguidehq/" rel="noopener noreferrer" target="_blank" className="link-block-19 w-inline-block">
                  <img src={instagramIcon} width="30" alt="" />
                </a>
                <a href="https://www.linkedin.com/company/startupguidehq" rel="noopener noreferrer" target="_blank" className="link-block-19 w-inline-block">
                  <img src={linkedinIcon} width="30" alt="" />
                </a>
                <a href="https://www.youtube.com/channel/UC18_EcrqO9neawvpgQuTOZQ" rel="noopener noreferrer" target="_blank" className="link-block-19 w-inline-block">
                  <img src={youtubeIcon} width="30" alt="" />
                </a>
              </div>
            </div>
          </nav>
        </div>
        <NavigationBar>
          <Brand link="/" image={sgLogo} />
          <div className="mainMenu" style={{ display: 'flex' }}>
            <div
              className="stores_menu"
              onMouseEnter={() => this.setState({ citiesMenu: true })}
              onMouseLeave={() => this.setState({ citiesMenu: false })}
            >
              <div data-w-id="19b4e80e-85ac-c786-a38c-d0b7cd93a8df" className="dropdown-trigger-copy">
                <Link to={citiesLink} className="link-2">All Locations</Link>
                <img alt="" src={arrowIcon} width={14} className="image-20" />
              </div>
              <div
                data-w-id="1674d0fd-9654-3420-f1d8-913bd8346eb6"
                className="dropdown-citiesv-s modified-menu"
                style={{ display: this.state.citiesMenu ? 'flex' : 'none' }}
              >
                <div className="div-block-38">
                  <img alt="" src={arrowDownIcon} width={18} className="image-33" />
                  <input
                    style={{ border: 'none', outline: 'none' }}
                    className="text-block-27"
                    placeholder="Type to search"
                    value={this.state.citiesSearchValue}
                    onChange={(event) => this.setState({
                      citiesSearchValue: event.target.value.trim().toLowerCase()
                    })}
                  />
                </div>
                <div className="unordered-list-3 w-list-unstyled ul-custom">
                  {cities
                    .filter(citiesSearchFilter)
                    .slice(0, cities.length / 2)
                    .map(c => (c.availability === 'ComingSoon' &&
                      <a key={++i} href={"/shop/startup-guide-" + removeAccents(c.name.toLowerCase().replace(' ', '-'))}>
                        <div className="li-custom dropdown_cities_list noclick">
                          <div>
                            {c.name}&nbsp;
                            {c.availability === 'ComingSoon' &&
                              <span className="soon">SOON </span>
                            }
                          </div>
                        </div>
                      </a>
                    )
                      ||
                      <a key={++i} href={c.link}>
                        <div className="li-custom dropdown_cities_list">
                          <div>
                            {c.name}
                          </div>
                        </div>
                      </a>
                    )}
                  {/* <ul className="unordered-list-2 unordered-list-3 w-list-unstyled"> */}
                  {cities
                    .filter(citiesSearchFilter)
                    .slice(cities.length / 2, cities.length)
                    .map(c => (c.availability === 'ComingSoon' &&
                      <a key={++i} href={"/shop/startup-guide-" + removeAccents(c.name.toLowerCase().replace(' ', '-'))}>

                        <div className="li-custom dropdown_cities_list noclick">
                          <div>
                            {c.name}&nbsp;
                            {c.availability === 'ComingSoon' &&
                              <span className="soon">SOON </span>
                            }
                          </div>
                        </div>
                      </a>
                    ) ||
                      <a key={++i} href={c.link}>
                        <div className="li-custom dropdown_cities_list">
                          <div>
                            {c.name}
                          </div>
                        </div>
                      </a>
                    )}
                  {/* </ul> */}
                </div>
              </div>
            </div>
            <div
              className="stores_menu"
            >
              <div data-w-id="41fe5db7-fa2d-51d7-928e-325cf33a350d" className="dropdown-trigger-copy">
                <Link to={"/about"} className="categories">About us</Link>
              </div>
            </div>
          </div>
          <nav className="nav-li account right w-nav-menu">
            <div className="search-wrapper">
              <img alt=""
                src={searchIcon}
                className="nav-icon"
                onClick={() => this.setState({ isSearchOpened: !this.state.isSearchOpened })}
              />
            </div>
            <Link to={onlineStoreLink} className="nav-link current w-nav-link">SHOP</Link>
            {/*<div className="bag">
                            <Link to="#" data-w-id="ee0421bb-f676-1f11-a712-0a7a0d56eae6" className="bag-link-page w-inline-block">
                                <img alt="" src={checkoutBasketIcon} className="image-3" />
                            </Link>
                            <div data-w-id="95bce950-a35f-2276-b7e5-e5f453d27151" className="shoppingcart w-hidden-small w-hidden-tiny">
                                <div>
                                    <div className="text-block-57">BASKET</div>
                                    <div className="bag-content">
                                        Your basket is empty ― find your books <Link to={onlineStoreLink} className="link-13">here</Link>.
                                    </div>
                                </div>
                                <div className="div-block-57">
                                    <div className="bag-total">TOTAL </div>
                                    <div className="div-block-56">0 €</div>
                                </div>
                                <div className="div-block-58">
                                    <div className="text-block-58">CHECKOUT</div>
                                </div>
                            </div>
                        </div>*/}
            {/* TODO: Implement login and registration
                        <Link to="#" data-w-id="c57e1db7-266d-113d-acb6-912994423a4b" className="nav-link login w-nav-link">Log in</Link>
                        <Link to="#" data-w-id="2176e6b6-335f-3a1e-d0a0-b8de8dfbb167" className="nav-link w-nav-link">Register</Link>
                        */}
          </nav>
          <div className="w-nav-button">
            <div className="w-icon-nav-menu" />
          </div>
        </NavigationBar>
        <div
          data-w-id="9793623d-4fbb-beac-3425-6e645791ba84"
          className="searchbox"
          style={{ width: '100%', display: this.state.isSearchOpened ? 'block' : 'none' }}
        >
          <div className="div-block-93">
            <form action="/search" className="search-2">
              <input type="search" style={{ "height": "auto" }} className="search-input-3 w-input" maxLength={256} autoFocus="true" name="query" placeholder="Type to search" id="search" required />
              <div className="div-block-94">
                <input type="submit" defaultValue="RESULTS" className="search-button-2 w-button" />
                <img alt="" src={arrowDownIcon} width={18} className="image-85" />
              </div>
            </form>
          </div>
        </div>
        {this.props.children}
      </Wrapper>
    )
  }
}

const connectRelay = App => class extends Component {

  render() {
    const { routeResolver } = this.props.context
    // console.log(this.props)
    let cities = [...this.props.query.cities]
    cities.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1)

    const props = {
      citiesLink: this.props.context.routeResolver.locations.get(),
      cities: cities.map(c => ({
        link: routeResolver.location.get(c.slug),
        ...c,
      })).sort((a, b) => {
        // Use toUpperCase() to ignore character casing
        const genreA = a.slug.toUpperCase();
        const genreB = b.slug.toUpperCase();

        let comparison = 0;
        if (genreA > genreB) {
          comparison = 1;
        } else if (genreA < genreB) {
          comparison = -1;
        }
        return comparison;
      }),
      categoriesLink: this.props.context.routeResolver.categoryList.get(),
      categories: this.props.query.categories.map(c => ({
        link: routeResolver.category.get(c.slug),
        ...c,
      })),
      storesLink: this.props.context.routeResolver.stores.get(),
      stores: this.props.query.stores.map(c => ({
        link: routeResolver.store.get(c.slug),
        ...c,
      })).sort((a, b) => {
        // Use toUpperCase() to ignore character casing
        const genreA = a.slug.toUpperCase();
        const genreB = b.slug.toUpperCase();

        let comparison = 0;
        if (genreA > genreB) {
          comparison = 1;
        } else if (genreA < genreB) {
          comparison = -1;
        }
        return comparison;
      }),
      onlineStoreLink: this.props.context.routeResolver.onlineStore.get(),
      aboutLink: this.props.context.routeResolver.about.get(),
    }

    return (
      <App {...props}>
        {this.props.children}
        <Footer footer={this.props.query.footer} />
      </App>
    )
  }
}

const AppContainer = createFragmentContainer(
  connectRelay(App),
  graphql`
        fragment app_query on Query {
            cities {
                slug
                name
                availability
            }
            stores {
                slug
                name
            }
            categories {
                slug
                name
                availability
            }
            footer {
                ...footer_footer
            }
        }
    `
)

export default (props) => <AppContainer query={props} {...props} />

function removeAccents(s) {
  var r = s.toLowerCase();
  // r = r.replace(new RegExp(/\s/g),"");
  r = r.replace(new RegExp(/[àáâãäå]/g), "a");
  r = r.replace(new RegExp(/æ/g), "ae");
  r = r.replace(new RegExp(/ç/g), "c");
  r = r.replace(new RegExp(/[èéêë]/g), "e");
  r = r.replace(new RegExp(/[ìíîï]/g), "i");
  r = r.replace(new RegExp(/ñ/g), "n");
  r = r.replace(new RegExp(/[òóôõö]/g), "o");
  r = r.replace(new RegExp(/œ/g), "oe");
  r = r.replace(new RegExp(/[ùúûü]/g), "u");
  r = r.replace(new RegExp(/[ýÿ]/g), "y");
  r = r.replace(/ /g, "-");
  
  // r = r.replace(new RegExp(/\W/g),"");
  return r;
};
